/**
 * The Zing Health case management department, assumed to be the only
 * department of hospital 14082 (ZING_HOSPITAL_ID). Gates the Members tab and
 * the IOP-526 order-form subset.
 */
export const ZING_CASE_MANAGEMENT_DEPARTMENT_ID = 13646;
